import React from "react";
import { SiteFooter } from "@/components/shared/SiteFooter";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen flex flex-col bg-[#0b1020] text-slate-100">
      <main className="flex-1 px-4 py-16">
        <article data-testid="privacy-policy-page" className="max-w-3xl mx-auto rounded-2xl border border-white/10 bg-white/[0.04] p-8 shadow-xl">
          <h1 data-testid="privacy-policy-title" className="text-3xl font-semibold mb-6">Politique de confidentialité</h1>
          <p data-testid="privacy-policy-placeholder" className="text-sm text-slate-300 leading-relaxed">
            Contenu à venir.
          </p>
        </article>
      </main>
      <SiteFooter />
    </div>
  );
}
